const CONTENT_WIDGET_HEIGHT = 100;
const ARROW_HEIGHT = 42;
export const customArrowClassName = `top-[calc(50%+(${CONTENT_WIDGET_HEIGHT}px-${ARROW_HEIGHT}px)/2)]`;
